/* CAS DEIÀ · Black Friday Early Access · diseño oscuro "todo en uno" (10-oct-2026).
   Tres cosas: la cuenta atrás, los dos formularios → Klaviyo y la parrilla de piezas con la wishlist.

   KLAVIYO va por la API pública de cliente (company id + id de lista, nunca una clave privada), igual que
   el pie de la web: el EMAIL entra en la lista del Black Friday y el MÓVIL (opcional) en la lista de SMS,
   en DOS llamadas, para que un número mal escrito no tumbe el alta del email.

   LA WISHLIST es la del tema (assets/members-wishlist.js, que carga el layout). Este fichero NO la vuelve a
   cargar: dos copias escucharían el mismo clic y el corazón guardaría y quitaría a la vez. Aquí solo se LEE
   lo guardado para poner esas piezas las primeras. */
(function () {
  var doc = document;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var each = function (sel, fn) { var els = doc.querySelectorAll(sel); for (var i = 0; i < els.length; i++) fn(els[i]); };

  /* --- cuenta atrás --- */
  var bar = doc.querySelector('.bfx-bar');
  // Safari no entiende "2026-11-08 19:00" con espacio: se le pone la T por si alguien lo escribe así en el editor.
  var target = Date.parse(String((bar && bar.getAttribute('data-bfx-target')) || '').trim().replace(' ', 'T'));
  var timer = null;
  function tick() {
    if (isNaN(target)) return;
    var left = Math.max(0, target - Date.now());
    if (!left) {
      if (bar) {
        var txt = bar.querySelector('[data-bfx-bar-text]'), cnt = bar.querySelector('[data-bfx-short]');
        if (txt) txt.textContent = bar.getAttribute('data-open-text') || 'Early Access is open';
        if (cnt) cnt.textContent = '';
      }
      each('[data-bfx-until]', function (el) { el.hidden = true; });
      if (timer) clearInterval(timer);
      return;
    }
    var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60;
    var v = { d: pad(d), h: pad(h), m: pad(m) };
    var corto = d + 'D ' + v.h + 'H ' + v.m + 'M', leido = d + ' days, ' + h + ' hours, ' + m + ' minutes';
    each('[data-bfx-u]', function (el) { el.textContent = v[el.getAttribute('data-bfx-u')]; });
    each('[data-bfx-short]', function (el) { el.textContent = corto; });
    each('[data-bfx-sr]', function (el) { el.textContent = leido; });
  }
  if (bar) {
    tick(); timer = setInterval(tick, 15000);
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) tick(); });
  }

  /* --- formularios --- */
  // Con corte a los 12 s: en una cobertura mala el botón no puede quedarse apagado un minuto sin decir nada.
  function alta(company, lista, origen, perfil) {
    var ctl = window.AbortController ? new AbortController() : null;
    var corte = ctl ? setTimeout(function () { ctl.abort(); }, 12000) : null;
    var listo = function () { if (corte) clearTimeout(corte); };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' },
      signal: ctl ? ctl.signal : undefined,
      body: JSON.stringify({ data: { type: 'subscription',
        attributes: { custom_source: origen, profile: { data: { type: 'profile', attributes: perfil } } },
        relationships: { list: { data: { type: 'list', id: lista } } } } })
    }).then(function (r) {
      listo();
      if (r.status === 202 || r.ok) return true;
      return r.text().then(function (t) { throw new Error(r.status + ' ' + t.slice(0, 200)); });
    }, function (x) { listo(); throw x; });
  }
  // El móvil, a formato internacional. Quien lo escribe ya con su prefijo (+34… o 0034…) se respeta tal cual.
  // ⚠️ SIN PREFIJO NO SE ENVÍA. Si el país del visitante no está en la lista, el desplegable sale en "Other" y
  // hay que escribir el número con su +: ponerle +34 por defecto guardaría el consentimiento de SMS a nombre
  // de un número español que es de otra persona.
  function movil(form) {
    var campo = form.querySelector('input[type=tel]'), pre = form.querySelector('select');
    var crudo = campo ? (campo.value || '').trim() : '';
    if (!crudo) return { valor: '' };
    var conPrefijo = /^(\+|00)/.test(crudo), num = crudo.replace(/[^0-9]/g, ''), elegido = pre ? pre.value : '';
    num = conPrefijo ? num.replace(/^00/, '') : num.replace(/^0+/, '');
    if (!conPrefijo && !elegido) return { mal: true };
    if (num.length < 6 || num.length > 15) return { mal: true };
    return { valor: conPrefijo ? '+' + num : elegido + num };
  }
  function aviso(form, cual, campo) {
    var err = form.querySelector('.bfx-err');
    if (err) { err.textContent = err.getAttribute('data-' + cual) || err.getAttribute('data-failed') || ''; err.hidden = false; }
    if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
  }
  function limpia(form) {
    var err = form.querySelector('.bfx-err'); if (err) err.hidden = true;
    var mal = form.querySelectorAll('[aria-invalid]'); for (var i = 0; i < mal.length; i++) mal[i].removeAttribute('aria-invalid');
  }
  function hecho(caja, foco) {
    var form = caja.querySelector('form'), ok = caja.querySelector('.bfx-joined');
    if (!form || !ok || form.hidden) return;
    form.hidden = true; ok.hidden = false;
    var h = ok.querySelector('h2'); if (foco && h) h.focus({ preventScroll: true });
  }
  var cajas = doc.querySelectorAll('[data-bfx-join]'), avisado = false;
  // El email ya está en la lista: se cuenta una sola vez, la otra caja de solo email pasa a "You're in" y la
  // del móvil SE QUEDA abierta con el email ya puesto, para que quien quiera pueda dejar su número.
  function yaDentro(email, caja) {
    if (!avisado) {
      avisado = true;
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); else if (window._learnq) window._learnq.push(['identify', { $email: email }]); } catch (e) {}
      try { if (window.dataLayer) window.dataLayer.push({ event: 'bf_early_access_signup' }); } catch (e) {}
    }
    for (var i = 0; i < cajas.length; i++) {
      var otra = cajas[i]; if (otra === caja) continue;
      var f = otra.querySelector('form'); if (!f) continue;
      if (f.querySelector('input[type=tel]')) { var em = f.querySelector('input[type=email]'); if (em && !em.value) em.value = email; }
      else hecho(otra, false);
    }
  }
  function enviar(caja) {
    var form = caja.querySelector('form');
    if (form.getAttribute('aria-busy') === 'true') return;
    var cebo = form.querySelector('[name=bfx_hp]'); if (cebo && cebo.value) return;      /* robots */
    var campo = form.querySelector('input[type=email]'), tel = form.querySelector('input[type=tel]'), btn = form.querySelector('button[type=submit]');
    var email = (campo.value || '').trim();
    limpia(form);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { aviso(form, 'invalid', campo); return; }
    var mv = movil(form);
    var company = form.getAttribute('data-company'), lista = form.getAttribute('data-list'), sms = form.getAttribute('data-sms-list'),
      origen = form.getAttribute('data-source') || 'Black Friday 2026 LP';
    if (!company || !lista) { aviso(form, 'failed'); return; }
    form.setAttribute('aria-busy', 'true'); if (btn) btn.disabled = true;
    // ⚠️ EL EMAIL VA PRIMERO Y SIEMPRE. Un móvil mal escrito no puede costar el alta: se apunta el email y
    // después se avisa del número, con el formulario abierto para corregirlo.
    alta(company, lista, origen, { email: email, properties: { 'Black Friday 2026 LP': 'yes' }, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } })
      .then(function () {
        yaDentro(email, caja);
        if (mv.mal) return 'phone';
        if (!mv.valor || !sms) return 'ok';
        return alta(company, sms, origen, { email: email, phone_number: mv.valor, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } })
          .then(function () { return 'ok'; }, function (x) { try { console.warn('[bf] Klaviyo sms', x.message); } catch (e) {} return 'phone'; });
      }, function (x) { try { console.warn('[bf] Klaviyo', x.message); } catch (e) {} return 'failed'; })
      .catch(function () { return 'failed'; })
      .then(function (res) {
        form.removeAttribute('aria-busy'); if (btn) btn.disabled = false;
        if (res === 'ok') hecho(caja, true);
        else aviso(form, res, res === 'phone' ? tel : null);
      });
  }
  for (var j = 0; j < cajas.length; j++) (function (caja) {
    var form = caja.querySelector('form'); if (!form) return;
    form.addEventListener('submit', function (e) { e.preventDefault(); enviar(caja); });
    form.addEventListener('input', function () { limpia(form); });
  })(cajas[j]);
  // Al volver atrás a la página guardada por el navegador, ningún botón puede seguir apagado.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    each('[data-bfx-join] form', function (f) { f.removeAttribute('aria-busy'); var b = f.querySelector('button[type=submit]'); if (b) b.disabled = false; });
  });

  /* --- las piezas: las guardadas en la wishlist, primero --- */
  var grid = doc.querySelector('[data-bfx-grid]');
  if (grid) (function () {
    // TODA = «Enseñar TODA la wishlist»: salen todas las guardadas (tope de 30 para no hacer la página eterna) y
    // detrás las fijas que no estén ya guardadas. Sin TODA: como antes, nunca más piezas que fijas.
    var TODA = grid.getAttribute('data-all') === '1', TOPE = 30;
    var fijas = [].slice.call(grid.children), max = TODA ? TOPE : fijas.length, nodos = {}, sinFicha = {};
    // ⚠️ La cuenta manda si hay sesión: el tema solo funde la lista del navegador con la de la cuenta UNA vez por
    // pestaña. Aquí se le quita esa marca (este script corre antes que members-wishlist.js), así que cada visita a
    // esta página trae lo que la persona tenga guardado en su cuenta en ese momento, venga del móvil o de otro PC.
    if (TODA) { try { sessionStorage.removeItem('casdeia:wishlist:fundido'); } catch (e) {} }
    fijas.forEach(function (n) { nodos[n.getAttribute('data-handle')] = n; });
    var cuenta = doc.querySelector('[data-bfx-saved]');
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var zoomAnillo = grid.getAttribute('data-ring-zoom') || '1', txtCorazon = grid.getAttribute('data-heart-label') || 'Save to wishlist:';
    var deAqui = false, ultima = null, vuelta = 0;

    function guardadas() {
      try {
        var l = window.CasdeiaWishlist ? window.CasdeiaWishlist.leer() : JSON.parse(localStorage.getItem('casdeia:wishlist') || '[]');
        return (Array.isArray(l) ? l : []).map(function (i) { return i && i.h; }).filter(Boolean);
      } catch (e) { return []; }
    }
    // la cifra no cuenta las piezas que ya no existen en la tienda (en modo TODA; antes se contaban)
    function pintaCuenta(l) { var n = TODA ? l.filter(function (h) { return !sinFicha[h]; }).length : l.length; if (cuenta) cuenta.textContent = (cuenta.getAttribute('data-tpl') || '').replace('[n]', String(n)); }
    // El precio de las fichas que monta el script, con el MISMO formato que pinta Liquid en las fijas (si la sección
    // lo dicta en data-money: una muestra de 1.234,56 formateada por Shopify). Sin muestra: formato inglés, "€60".
    var muestra = /^(.*?)1(.?)234(.)56(.*)$/.exec(grid.getAttribute('data-money') || '');
    function dinero(centimos) {
      var val = centimos / 100, entero = Math.round(val) === val, moneda = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      if (muestra) {
        var t = (entero ? String(val) : val.toFixed(2)).split('.');
        t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, muestra[2]);
        return muestra[1] + t.join(muestra[3]) + muestra[4];
      }
      try {
        return new Intl.NumberFormat(TODA ? 'en' : (doc.documentElement.lang || 'en'), { style: 'currency', currency: moneda, minimumFractionDigits: entero ? 0 : 2, maximumFractionDigits: entero ? 0 : 2 }).format(val);
      } catch (e) { return val.toFixed(entero ? 0 : 2) + ' ' + moneda; }
    }
    // Una pieza guardada que no está entre las fijas: se monta igual que las que pinta Liquid.
    function monta(p, handle) {
      var url = raiz + 'products/' + handle, art = doc.createElement('article');
      art.className = 'bfx-tile'; art.setAttribute('data-handle', handle);
      var caja = doc.createElement('div'); caja.className = 'bfx-tile-box';
      var a = doc.createElement('a'); a.href = url; a.setAttribute('aria-label', p.title || handle);
      if (p.featured_image) {
        var img = doc.createElement('img'), src = String(p.featured_image);
        var une = src.indexOf('?') > -1 ? '&' : '?', anillo = /(^|[^a-z])ring/i.test(p.type || '') && zoomAnillo !== '1';
        img.alt = p.title || ''; img.loading = 'lazy';
        // los anillos van ampliados: piden el doble de foto para no verse blandos (igual que en Liquid)
        // las medidas las dicta Liquid (data-sizes, data-widths) para que coincidan con las piezas fijas
        img.sizes = (anillo ? grid.getAttribute('data-sizes-ring') : grid.getAttribute('data-sizes')) || '29vw';
        img.srcset = (grid.getAttribute('data-widths') || '220,330,440,660,880').split(',').map(function (w) { return src + une + 'width=' + w + ' ' + w + 'w'; }).join(', ');
        img.src = src + une + 'width=330';
        if (anillo) img.style.setProperty('--bfx-z', zoomAnillo);
        a.appendChild(img);
      }
      caja.appendChild(a);
      var marco = fijas[0] && fijas[0].querySelector('.bfx-frame'); if (marco) caja.appendChild(marco.cloneNode(true));
      var cor = fijas[0] && fijas[0].querySelector('.bfx-heart');
      if (cor) {
        cor = cor.cloneNode(true);
        cor.setAttribute('data-wishlist', handle); cor.setAttribute('data-wishlist-talla', (p.variants && p.variants.length === 1) ? String(p.variants[0].id) : '');
        cor.setAttribute('aria-label', txtCorazon + ' ' + (p.title || handle));
        caja.appendChild(cor);
      }
      art.appendChild(caja);
      var nom = doc.createElement('div'); nom.className = 'bfx-tile-name';
      var an = doc.createElement('a'); an.href = url; an.textContent = p.title || handle; nom.appendChild(an); art.appendChild(nom);
      var pr = doc.createElement('div'); pr.className = 'bfx-tile-price'; pr.textContent = dinero(p.price); art.appendChild(pr);
      return art;
    }
    // ⚠️ SOLO UN 404 DA LA PIEZA POR PERDIDA. Un fallo de red no es una pieza borrada: se deja para la próxima
    // pintada (devuelve false y la parrilla se vuelve a intentar al regresar a la página).
    function ficha(handle) {
      return fetch(raiz + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) { sinFicha[handle] = 1; return null; }
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        })
        .then(function (p) { if (p) nodos[handle] = monta(p, handle); return true; })
        .catch(function () { return false; });
    }
    function pinta() {
      var l = guardadas(); pintaCuenta(l);
      var clave = l.join(','); if (clave === ultima) return; ultima = clave;
      var mia = ++vuelta;
      var faltan = l.slice(0, max).filter(function (h) { return !nodos[h] && !sinFicha[h]; });
      Promise.all(faltan.map(ficha)).then(function (res) {
        if (mia !== vuelta) return;                       // ha llegado una pintada más nueva: manda ella
        if (res.indexOf(false) > -1) ultima = null;       // algo no cargó: que la próxima lo reintente
        pintaCuenta(l);
        var orden = [];
        l.forEach(function (h) { if (orden.length < max && nodos[h] && orden.indexOf(nodos[h]) < 0) orden.push(nodos[h]); });
        fijas.forEach(function (n) { if ((TODA || orden.length < max) && orden.indexOf(n) < 0) orden.push(n); });
        var igual = orden.length === grid.children.length;
        for (var i = 0; igual && i < orden.length; i++) if (grid.children[i] !== orden[i]) igual = false;
        if (!igual) { while (grid.firstChild) grid.removeChild(grid.firstChild); orden.forEach(function (n) { grid.appendChild(n); }); }
        if (window.CasdeiaWishlist && window.CasdeiaWishlist.pintar) window.CasdeiaWishlist.pintar();
      });
    }
    // Un corazón pulsado AQUÍ no recoloca la parrilla (la pieza saltaría de sitio bajo el dedo): solo cambia
    // la cifra. Se reordena al volver a la página, que es cuando el cliente trae piezas nuevas de la web.
    grid.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-wishlist]')) { deAqui = true; setTimeout(function () { deAqui = false; }, 0); }
    }, true);
    doc.addEventListener('casdeia:wishlist', function () {
      if (deAqui) { var l = guardadas(); pintaCuenta(l); ultima = l.join(','); } else pinta();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) pinta(); });
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) pinta(); });
    window.addEventListener('storage', function (e) { if (!e.key || e.key === 'casdeia:wishlist') pinta(); });
    pinta();
  })();
})();
